/**
 * 客戶相關的工具函數
 */

export interface CustomerStatus {
  isArchived: boolean;
  statusText?: string;
}

/**
 * 檢查客戶是否被封存
 */
function isCustomerArchived(customer?: { archived?: boolean } | null): boolean {
  return customer?.archived === true;
}

/**
 * 獲取客戶狀態信息
 */
export function getCustomerStatus(customer?: { archived?: boolean } | null): CustomerStatus {
  const archived = isCustomerArchived(customer);
  return {
    isArchived: archived,
    statusText: archived ? 'common.archived' : undefined
  };
}

/**
 * 獲取封存客戶整列的樣式類名
 */
export function getArchivedRowClassName(customer?: { archived?: boolean } | null): string {
  return isCustomerArchived(customer) 
    ? 'opacity-35' 
    : '';
}

/**
 * 檢查封存客戶是否可編輯
 */
export function canEditArchivedCustomerData(customer?: { archived?: boolean } | null): boolean {
  // 封存客戶的關聯資料不能編輯，只能刪除
  return !isCustomerArchived(customer);
}